import React from "react";
import type { ProductEntity } from "../../../../../../domain/types/product";
import { PREVIEW_COLORS } from "../../constants";

interface PreviewRecentlyViewedProps {
  recentlyViewedProducts: ProductEntity[] | null;
  title?: string | null;
  subtitle?: string | null;
}

export const PreviewRecentlyViewed = ({
  recentlyViewedProducts,
  title,
  subtitle,
}: PreviewRecentlyViewedProps) => {
  return (
    <div className="text-start flex flex-col flex-start py-[40px] px-[32px]">
      <h2
        className="mb-[1.5rem] text-[1.125rem] font-semibold"
        style={{ color: PREVIEW_COLORS.sectionTitle }}
      >
        {title || "최근 둘러본 상품"}
      </h2>
      {subtitle ? (
        <div
          className="mt-[-1rem] mb-[1.5rem]"
          style={{ color: PREVIEW_COLORS.sectionSubtitle }}
        >
          {subtitle}
        </div>
      ) : null}
      <div className="grid grid-cols-[auto,auto] md:grid-cols-4 gap-[16px] / items-center">
        {recentlyViewedProducts?.map((item) => {
          return (
            <div className="w-full">
              <div
                className="drop-shadow-xl aspect-[1/1] rounded-[0.625rem] mb-[0.75rem]"
                style={{ backgroundColor: PREVIEW_COLORS.thumbnailPlaceholder }}
              >
                <img
                  src={item.thumbnail ?? ""}
                  alt="썸네일 이미지."
                  className="object-cover h-full rounded-[0.625rem] w-full"
                />
              </div>
              <div className="">
                <h4
                  className="font-medium"
                  style={{ color: PREVIEW_COLORS.recentlyViewed.productName }}
                >
                  {item.name}
                </h4>
                <span
                  style={{ color: PREVIEW_COLORS.recentlyViewed.productPrice }}
                >
                  ~{item.priceTiers?.[0]?.price ?? "-"}원
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
